module.exports = __webpack_public_path__ + "static/media/email_reset_password_confirm.b142eabe.png";